import LocalStorageService from './localStorage.service'

import axios from 'axios'

class MessageService {
    constructor(apiUrl) {
        this.apiUrl = apiUrl
    }


    /**
    * @author Adrian Montemayor
    * @description  Send a message via sms
     * @param {*} token
     * @returns
     * @memberof MessageService
     */
    async sendMessage(phoneNumber, promotion, email) {
        let response = await axios.post(`${this.apiUrl}/send-sms`, {
            phoneNumber,
            promotion,
            email
        })
        return response.data
    }

    /**
* @author Adrian Montemayor
* @description  Validate a message via sms
 * @param {*} token
 * @returns
 * @memberof MessageService
 */
    async validateMessage(code, userEmail) {
        let response = await axios.post(`${this.apiUrl}/validate-sms`, {
            code,
            userEmail
        })
        return response.data
    }

    /**
* @author Adrian Montemayor
* @description  Resend a message via sms
* @param {*} token
* @returns
* @memberof MessageService
*/
    async reSendMessage(phoneNumber, validationType, email) {
        let response = await axios.post(`${this.apiUrl}/resend-sms`, {
            phoneNumber,
            validationType,
            email
        })
        return response.data
    }


    /**
    * @author Edgar Escobedo
    * @description  Resend a message via sms or an email
    * @param {String} validationType
    * @param {String} email
    * @param {*} token
    * @returns
    * @memberof MessageService
    */
    async reSendMessageOrEmail(validationType, notificationType, email) {
        let response = await axios.post(`${this.apiUrl}/resend-sms-email`, {
            notificationType,
            validationType,
            email
        })
        return response.data
    }

    /**
    * @author Edgar Escobedo
    * @description  Validate code from login
    * @param {String} email
    * @param {String} code
    * @param {*} token
    * @returns
    * @memberof MessageService
    */
    async validateCodeLogin(email, code, validationType) {
        const localStorageService = new LocalStorageService()
        const jwt = localStorageService.getLocalStorageItem('jwtOnboarding')

        const response = await axios.post(
            `${this.apiUrl}/validate-code-login`,
            { email, code, validationType },
            {
                headers: {
                    Authorization: `Bearer ${jwt}`
                }
            }
        )
        return response.data
    }

}
export { MessageService as default }
